import Api from './baseApi';
export default {
    getSettings: () => Api.get('/api/Settings'),
    putSetting: (Setting) => Api.put(`/api/Settings/${Setting.id}`, Setting),
    postSetting: (Setting) => Api.post(`/api/Settings`, Setting)
}